module.exports = __webpack_public_path__ + "fonts/ToyotaType-LightIt.8cde3d9.woff2";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/ToyotaType-LightIt.woff2
// module id = NV/s
// module chunks = 13